import { registerLocaleData } from '@angular/common';
import { importProvidersFrom, LOCALE_ID, NgModule } from '@angular/core';
import localeDe from '@angular/common/locales/de';
import {
  AuthService,
  AuthTokenService,
  DialogService,
  ErrorHandlerService,
  FeedbackService,
  FileDownloadService,
  RequestService,
  RouterService,
  ServiceFacade,
  SharedModule,
  StorageService,
  ThemeService,
} from '@resident-nx/shared';
import {
  DialogWebService,
  ErrorHandlerWebService,
  FeedbackWebService,
  FileDownloadWebService,
  RequestWebService,
  RouterWebService,
  ServiceWebFacade,
  ThemeWebService,
} from './services';
import { ModalService } from './components/molecules/modal/modal.service';
import {
  AuthTokenWebService,
  AuthWebService,
  LocalStorageService,
  SessionStorageService,
} from '@resident-nx/web/data-access';

registerLocaleData(localeDe);

@NgModule({
  providers: [
    importProvidersFrom(SharedModule),
    { provide: AuthService, useClass: AuthWebService },
    { provide: AuthTokenService, useClass: AuthTokenWebService },
    { provide: RouterService, useClass: RouterWebService },
    { provide: DialogService, useClass: DialogWebService },
    { provide: FeedbackService, useExisting: FeedbackWebService },
    { provide: ThemeService, useExisting: ThemeWebService },
    { provide: RequestService, useClass: RequestWebService },
    { provide: StorageService, useClass: LocalStorageService },
    { provide: ServiceFacade, useClass: ServiceWebFacade },
    { provide: ErrorHandlerService, useClass: ErrorHandlerWebService },
    { provide: LOCALE_ID, useValue: 'de-DE' },
    SessionStorageService,
    LocalStorageService,
    ModalService,
    FileDownloadWebService,
    // Needed by cross-platform consumers that inject the abstract service, e.g. ContentTitleImagePipe.
    { provide: FileDownloadService, useExisting: FileDownloadWebService },
  ],
})
export class WebModule {}
